var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinearFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 14.5V9.5M3.125 9.5V3.25M3.125 9.5L4.66917 9.19119C5.70075 8.98488 6.77006 9.083 7.74681 9.47375C8.80531 9.89713 9.97025 9.97619 11.0763 9.69969L11.1388 9.68406C11.5051 9.5925 11.6788 9.17306 11.4846 8.84931L10.5092 7.22363C10.2958 6.86789 10.189 6.69003 10.1637 6.49657C10.1532 6.41587 10.1532 6.33413 10.1637 6.25343C10.189 6.05997 10.2958 5.88211 10.5092 5.52638L11.3083 4.19458C11.5174 3.846 11.2007 3.41858 10.8063 3.51716C9.87581 3.74979 8.89569 3.68327 8.00513 3.32706L7.74681 3.22373C6.77006 2.83302 5.70075 2.73485 4.66917 2.94117L3.125 3.25M3.125 3.25V2",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinearFlag);
export default __webpack_public_path__ + "static/media/icon-linear-flag.aa4697ba86871efe060d0761540da493.svg";
export { ForwardRef as ReactComponent };